var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{staticClass:"h-100",attrs:{"show":_vm.status === 'loading' && !_vm.editMode}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-group-title"},[_c('h4',{staticClass:"card-title"},[_vm._v(" "+_vm._s(_vm.$t('org.dashboard.Monthly Cost'))+" ")]),_c('h6',{staticClass:"card-subtitle"},[_vm._v(" "+_vm._s(_vm.$t('org.dashboard.12 month amount as of selected date'))+" ")])])]),_c('div',{style:({
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '24px',
            height: '24px',
            pointerEvents: 'none'
        }),attrs:{"id":"tour-edit-dashboard-step-4"}}),_c('BarChart',{staticClass:"dashboard-chart",attrs:{"data":_vm.chartData,"options":_vm.chartOptions,"styles":_vm.responsiveStyle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }